/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['pagi', 'pagi', 'tengah hari', 'petang', 'malam'],
    ,
  ],
  [
    ['pagi', 'pagi', 'tengah hari', 'petang', 'malam'],
    ['tengah malam', 'pagi', 'tengah hari', 'petang', 'malam'],
  ],
  [
    ['00:00', '01:00'], ['01:00', '12:00'], ['12:00', '14:00'], ['14:00', '19:00'],
    ['19:00', '24:00']
  ]
];
